import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleCardsSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100" id="articles">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-3 text-center">
          Artigos CSSBuy Spreadsheet
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12 max-w-xl mx-auto">
          Guias completos, dicas e informações atualizadas sobre o melhor CSSBuy Spreadsheet para compradores do Brasil e Portugal.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group flex flex-col bg-white border border-background-200 rounded-xl overflow-hidden hover:border-primary-300 hover:shadow-sm transition-all duration-200"
            >
              <div className="w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.imageAlt}
                  title={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 leading-snug group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                  {article.description}
                </p>
                <div className="mt-auto flex items-center justify-between">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readingTime}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors duration-200">
                    Ler mais
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}